import { Box, Switch, Typography } from "@mui/material";
import React, { Dispatch } from "react";

interface CustomerBoardsProps {
	newAddOnSettings: any; // TODO: Define type
	setNewAddOnSettings: Dispatch<any>;
}

const BOARDS: { key: string; title: string; blurb: string }[] = [
	{
		key: "revenueForecastingEnabled",
		title: "Revenue Forecasting",
		blurb:
			"Order backlog by week against site capacity, with revenue and the constraints holding jobs up.",
	},
	{
		key: "labBoardEnabled",
		title: "Lab Board",
		blurb:
			"Daily lab schedule against technician and bench capacity, with the floor view by day.",
	},
];

const CustomerBoards: React.FC<CustomerBoardsProps> = ({
	newAddOnSettings,
	setNewAddOnSettings,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				marginTop: "32px",
				padding: "16px",
			}}
		>
			{BOARDS.map((board, index) => (
				<Box
					key={board.key}
					sx={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
						marginTop: index === 0 ? 0 : "16px",
					}}
				>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<Typography
							sx={{
								fontFamily: "Roboto",
								fontWeight: 400,
								fontSize: "16px",
								color: "rgba(0, 0, 0, 0.87)",
							}}
						>
							{board.title}
						</Typography>
						<Typography
							sx={{
								fontFamily: "Roboto",
								fontWeight: 400,
								fontSize: "12px",
								color: "rgba(0, 0, 0, 0.6)",
							}}
						>
							{board.blurb}
						</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Switch
							checked={newAddOnSettings[board.key] ?? false}
							onChange={(e) => {
								setNewAddOnSettings((pre: any) => ({
									...pre,
									[board.key]: e.target.checked,
								}));
							}}
						/>
					</Box>
				</Box>
			))}
		</Box>
	);
};

export default CustomerBoards;
